
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

// @ts-ignore
import { codemirror } from "vue-codemirror";

import "codemirror/lib/codemirror.css";
import "codemirror/mode/php/php.js";

import * as n from "@/types/notifications";

@Component({
  components: {
    codemirror
  }
})
export default class StackTrace extends Vue {
  @Prop()
  value!: n.InternalServerErrorDetailsTrace[];

  getSnippetFromTrace(trace: n.InternalServerErrorDetailsTrace) {
    return Object.values(trace.snippet).join("");
  }

  onCmReady(cm: any, trace: n.InternalServerErrorDetailsTrace) {
    cm.addLineClass(
      Math.max(1, trace.line - trace.startingLine),
      "wrap",
      "breakdance-codemirror-errorneous-line"
    );
  }

  codemirrorOptions(trace: n.InternalServerErrorDetailsTrace) {
    return {
      tabSize: 4,
      mode: `text/x-php`,
      theme: "darcula",
      lineNumbers: true,
      firstLineNumber: trace.startingLine,
      lineWrapping: true,
      readOnly: true,
      scrollbarStyle: null,
      viewportMargin: Infinity
    };
  }
}
